export const backgroundOptions = [
    {
        label: 'Custom',
        value: 'custom',
    },
    {
        label: 'None',
        value: 'none',
    },
];

export const getSupportedContentTypes = (isBetaEnabled?: boolean) => {
    let types = [
        {
            label: 'List',
            value: 'list',
        },

        {
            label: 'Link',
            value: 'link',
        },

        {
            label: 'Text',
            value: 'scrollableText',
        },
        {
            label: 'HTML',
            value: 'html',
        },
        {
            label: 'Map',
            value: 'map',
        },
        {
            label: 'Image',
            value: 'zoomImage',
        },
        {
            label: 'Info',
            value: 'info',
        },
    ];

        types = [
            ...types,
            {
                label: 'Canvas',
                value: 'canvas',
            },
            {
                label: 'Webview',
                value: 'webview',
            },
            {
                label: 'Static',
                value: 'basic',
            }
        ];
        if(isBetaEnabled){
            types.push( {
                label: 'Guest List',
                value: 'guestList',
            })
        }

    return types;
};
